import { gql } from '@apollo/client';

export const LOAD_TYPES_QUERY = gql`
  query loadTypes {
    loadTypeDefaults {
      id
      description
    }
  }
`;

export interface LoadTypeRow {
  id: number;
  description: string;
}
export interface LoadTypesQueryResult {
  loadTypeDefaults: LoadTypeRow[];
}

export const AREA_CODES_QUERY = gql`
  query areaCodes {
    areaCodes(orderBy: postCode_ASC) {
      id
      area
      postCode
    }
  }
`;

export interface AreaCodeRow {
  id: number;
  area: string;
  postCode: string;
}
export interface AreaCodesQueryResult {
  areaCodes: AreaCodeRow[];
}

export const GENERATE_BUDGET_QUOTE = gql`
  mutation generateBudgetQuote(
    $sessionData: SessionDataInput
    $quoteData: QuoteDataInput
    $contactDetails: BudgetQuoteContactInput!
  ) {
    generateBudgetQuote(
      sessionData: $sessionData
      quoteData: $quoteData
      contactDetails: $contactDetails
    )
  }
`;

export interface GenerateBudgetQuoteResult {
  generateBudgetQuote: {
    result?: {
      budgetQuoteId: number;
      drawing: unknown;
      backsheet: unknown;
      quoteData?: unknown;
      infoMessage?: string;
    };
    warnings?: string[];
    errors?: string[];
  };
}

export const SEND_ACCESS_REQUEST_EMAIL = gql`
  mutation sendEmail($sendEmailInput: SendEmailInput!) {
    sendEmail(sendEmailInput: $sendEmailInput)
  }
`;
